import {RoadKill} from "../RoadKill";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {gsap, TimelineMax} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";


export class RoadKillFreeOutroRunner implements SimplePresentation {
    shouldRun(): boolean {
        const mode: string = RoadKill.model.gameData.mode,
            nextMode: string = RoadKill.model.gameData.nextMode;
        return (mode === RoadKillGameMode.FREESPIN || mode === RoadKillGameMode.FREESPIN_SUPER || mode=== RoadKillGameMode.RESPIN) && nextMode === RoadKillGameMode.NORMAL && !RoadKill.model.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const mainTl: TimelineMax = new TimelineMax();
        controller.setSkipCallback(undefined);
        mainTl.add([RoadKill.initialWinView.hideCountUp(), RoadKill.bigWinView.hideCountUp()
            , () => {
                RoadKill.keypadPlugin.setZeroBetSpinCounter(-1);
            }]);
        mainTl.add(RoadKill.fsOutroView.showOutroView(() => this.fsOutroClosedCallback(controller)));
    }

    private fsOutroClosedCallback(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.finish();
            }
        });
    }
}